import { FunctionComponent } from 'react';
import { useCurrentProfile } from '@/api/user/ProfileProvider';
import { useFooter } from '@tv2-cas/offspring/api/footer/useFooter';
import { Footer } from './footer/Footer';

export const PageFooter: FunctionComponent = () => {
  const { isParentalControlled } = useCurrentProfile();
  const { footer, fetching } = useFooter();

  if (isParentalControlled || fetching || !footer) return null;
  return <Footer footerData={footer} />;
};
